// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Sn2O","footer":"ModalInfo_footer__3ibXv"};